import { useDispatch } from '@/hooks/dispatch'
import { actionCreators as myTicketsActionCreators } from '@/store/MyTickets'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import React, { useCallback } from 'react'
import { dialogTypes } from '@/dialogs'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'

function CreateTicketButton ({ onClick, className }) {
  const [clearTicketServerError, openDialog] = useDispatch([myTicketsActionCreators.clearError, dialogActions.openDialog])
  const onClickInternal = useCallback(() => {
    clearTicketServerError()
    openDialog({ dialogType: dialogTypes.newTicket })
    // onTaskNavigate()
    if (typeof onClick === 'function') onClick()
  }, [clearTicketServerError, onClick, openDialog])
  const isGranted = usePermissionChecker()
  if (!isGranted('Workflows.')) return null
  return (
    <button className={className} onClick={onClickInternal}>
      <Icon name='plus' />
      <Resx name='Tickets.CreateTicket' />
    </button>
  )
}

export {
  CreateTicketButton
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/createTicketButton.js